abstract class BaseModel {
    id: number;
    createdDate: Date;
    modifiedDate?: Date;
    createdById?: number;
    modifiedById?: number;
}

export { BaseModel }